var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item-group',{staticClass:"milista",attrs:{"color":"green"},model:{value:(_vm.selectedIndex),callback:function ($$v) {_vm.selectedIndex=$$v},expression:"selectedIndex"}},_vm._l((_vm.pages_list),function(item,index){return _c('v-list-item',{key:index},[_c('created-page',{attrs:{"page":item}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }